import React from 'react';

import NavigationFull from './Full';
import NavigationCampaign from './Campaign';
import NavigationPrivacy from './Privacy';
import NavigationKP from './KP';

const Navigation = ({ variant, campaignEntity }) => {
  switch (variant) {
    case 'campaign':
      return <NavigationCampaign campaignEntity={campaignEntity} />;
    case 'privacy':
      return <NavigationPrivacy />;
    case 'kp':
      return <NavigationKP />;
    default:
      return <NavigationFull />;
  }

};

export default Navigation;
